var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"pin",rawName:"v-pin",value:(_vm.pin),expression:"pin"}],staticClass:"data-grid__thead"},[_c('div',{staticClass:"data-grid__row data-grid__row_header"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }